 export interface IGetDocusignRedirectPathRequest {
        envelopeRemoteId: string;
        signingComplete: boolean;
    }

    export class GetDocusignRedirectPathRequest implements IGetDocusignRedirectPathRequest {
        envelopeRemoteId: string;
        signingComplete: boolean;

        constructor(envelopeRemoteId: string, signingComplete: boolean) {
            this.envelopeRemoteId = envelopeRemoteId;
            this.signingComplete = signingComplete;
        }
    }
